<template>
  <div class="testers-detail-container">
    <div class="testers-detail-header">
      <div class="header-left">
        <div class="testers-detail-title">
          <div class="testers-detail-title-text">Testers</div>
        </div>
        <div class="testers-detail-name">
          <div class="testers-detail-name-text" v-if="recording.name">
            {{ recording.name }}
          </div>
          <div class="recording-detail-name-text" v-else>No Name</div>
        </div>
      </div>
    </div>

      <hr class="divider" />
            <div class="testers-detail-body">
        <div class="testers-detail-description">
          <div class="testers-detail-subtitle category">
              <div class="testers-section">
              <div class="section-header-row">
                <div class="section-header">Your Assigned Testers</div>
                <label class="select-all-box">Select All <input type="checkbox" v-model="selectAllAssigned" @change="selectedAllAssigned"> </label>
              </div>
              <div v-if="sessionTesters.length === 0" class="empty-hint">No testers assigned to this session yet.</div>
              <div v-for="user in sessionTesters" :key="'session-' + user.id">
                <div class="user-slot">
                  <label class="user-name">
                    {{user.name}}
                    <span v-if="!user.pendingSelected" class="pending-tag pending-remove">Removing</span>
                  </label>
                  <input type="checkbox" class="user-checkbox" :checked="!user.pendingSelected" @change="toggleAssignedRemoval(user, $event)">
                </div>
              </div>
            </div>

              <div class="testers-section">
              <div class="section-header-row">
                <div class="section-header">Add New Testers</div>
                <label class="select-all-box">Select All <input type="checkbox" v-model="selectAll" @change="selectedAll"> </label>
              </div>
              <div v-if="availableTesters.length === 0" class="empty-hint">All project testers are already assigned to this session.</div>
              <div v-for="user in availableTesters" :key="'available-' + user.id">
                <div class="user-slot">
                  <label class="user-name">
                    {{user.name}}
                    <span v-if="user.pendingSelected" class="pending-tag pending-add">Adding</span>
                  </label>
                  <input type="checkbox" class="user-checkbox" v-model="user.pendingSelected" @change="handlePendingChange">
                </div>
              </div>
            </div>

            <button
              class="update-assignments-btn"
              :disabled="!hasPendingAssignmentChanges"
              @click="confirmAssignmentChanges"
            >
              Update Assignments
            </button>

          </div>
        </div>
        
      </div>

    <!-- Save Button - moved outside the scrollable body -->
    <div class="save-button-container">
      <button class="save-button" @click="showConfirmDialog" :disabled="!hasChanges">
        Save
      </button>
    </div>

    <!-- Confirmation Dialog -->
    <div v-if="showDialog" class="dialog-overlay">
      <div class="dialog-box">
        <div class="dialog-content">
          <h3>Confirm Changes</h3>
          <p>Are you sure you want to add these new testers?</p>
          <div class="dialog-buttons">
            <button class="dialog-button confirm-button" @click="confirmSave">Yes</button>
            <button class="dialog-button cancel-button" @click="cancelSave">No</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Response from "../../../Firestore/Response";
import GamesObject from "../../../Firestore/GamesObject";
import UserObject from "../../../Firestore/UserObject";
import Template from "../../../Firestore/Template"; 

export default {
  name: "testers",
  components: {



  },
  props: {
    detail: {
      type: Object
    },
    recording: {
      type: Object
    }
  },
  data() {
    return {
      recordingObj: [],
      testerList: [],
      currTester: null,
      currTesterID: 0,
      testerResponse: {},
      individual: true,
      allResponses: [],
      userProfiles: [],
      selectAll: false,
      selectAllAssigned: false,
      // New data properties for save functionality
      originalSelections: [], // Store original state
      showDialog: false,
      hasChanges: false
    };
  },

    computed: {
    sessionTesters() {
      return this.userProfiles.filter(user => user.selected);
    },
    availableTesters() {
      return this.userProfiles.filter(user => !user.selected);
    },
    hasPendingAssignmentChanges() {
      return this.userProfiles.some(user => user.pendingSelected !== user.selected);
    }
  },

    watch: {
    recording(newPlayPeriod, oldPlayPeriod) {
      let existingTesters = this.recording.testerIDs;
      this.userProfiles.forEach(user => {
        user.selected = existingTesters.includes(user.id);
        user.pendingSelected = user.selected;
      });
      this.saveOriginalSelections();
    }
  },

  mounted() {
    const res = GamesObject.getTestersFromProject(window.localStorage.getItem("gameId"))
      .then(res => {
        let list = []
        let existingTesters = this.recording.testerIDs || [];
        res.data.testerIds.forEach(id => {
          this.$data.testerList.push(id);
        });
          this.$data.testerList.forEach(id => {
          UserObject.getProfile(id)
            .then(res => {
              let isAssigned = existingTesters.includes(id);
              let user = { 'id': id, 'name': res.data.userName, 'selected': isAssigned, 'pendingSelected': isAssigned };
              this.$data.userProfiles.push(user);
              // Save original selections after all users are loaded
              if (this.$data.userProfiles.length === this.$data.testerList.length) {
                this.saveOriginalSelections();
              }
            })
        })
      });
    if(window.localStorage.getItem("userType")) {
      this.userType = parseInt(window.localStorage.getItem("userType"));
    } else {
      this.$router.push({
        name: 'login',
      })
    }
  },

  methods: {
    toDetailAnalysis() {
      this.$emit("toDetailAnalysisChild");
    },
    getProfile(userid) {
      UserObject.getProfile(userid)
      .then(res => {

      })
    },
    getNewlyAddedTesters() {
  const previous = this.originalSelections
    .filter(u => u.selected)
    .map(u => u.id);

  const current = this.userProfiles
    .filter(u => u.selected)
    .map(u => u.id);

  return current.filter(id => !previous.includes(id));
},

    
    saveOriginalSelections() {
      this.originalSelections = this.userProfiles.map(user => ({
        id: user.id,
        selected: user.selected
      }));
      // Keep staged checkboxes in sync with the committed state
      this.userProfiles.forEach(user => {
        user.pendingSelected = user.selected;
      });
      this.hasChanges = false;
    },

    
    checkForChanges() {
      const currentSelections = this.userProfiles.map(user => ({
        id: user.id,
        selected: user.selected
      }));
      
      this.hasChanges = JSON.stringify(currentSelections) !== JSON.stringify(this.originalSelections);
    },


      handlePendingChange() {
      this.selectAll = this.availableTesters.length > 0 && this.availableTesters.every(user => user.pendingSelected);
    },

    toggleAssignedRemoval(user, event) {
      user.pendingSelected = !event.target.checked;
      this.selectAllAssigned = this.sessionTesters.length > 0 && this.sessionTesters.every(u => !u.pendingSelected);
    },

    confirmAssignmentChanges() {
      this.userProfiles.forEach(user => {
        user.selected = user.pendingSelected;
      });
      this.selectAll = false;
      this.selectAllAssigned = false;
      this.checkForChanges();
    },
    updateSelectedUsers() {
      let userIDs = [];
      this.userProfiles.forEach(user => {
        if (user.selected) userIDs.push(user.id);
      });

      return GamesObject.updateTestersToPlayPeriod(
        this.recording.playPeriodID,
        userIDs
      );
    },

    selectedAll() {
      this.availableTesters.forEach(user => {
        user.pendingSelected = this.selectAll;
      });
    },
      selectedAllAssigned() {
      this.sessionTesters.forEach(user => {
        user.pendingSelected = !this.selectAllAssigned;
      });
    },

  
    showConfirmDialog() {
      if (this.hasChanges) {
        this.showDialog = true;
      }
    },

  
async confirmSave() {
  const gameId = this.recording.gameID;
  const playSessionId = this.recording.playPeriodID;

  try {
    await this.updateSelectedUsers();
    await Template.sendPlaySessionCreatedNotification(gameId, playSessionId);
    console.log("PlaySession notification sent");
    this.saveOriginalSelections();
  } catch (error) {
    console.error("Failed to save testers:", error);
  } finally {
    this.showDialog = false;  // This now ALWAYS runs, success or failure
  }
},

    cancelSave() {
      this.userProfiles.forEach(user => {
        const originalUser = this.originalSelections.find(orig => orig.id === user.id);
        if (originalUser) {
          user.selected = originalUser.selected;
          user.pendingSelected = originalUser.selected;
        }
      });
      
      const allSelected = this.userProfiles.every(user => user.selected);
      this.selectAll = allSelected;
      
      this.hasChanges = false;
      this.showDialog = false;
    },

    /*
    async getTesterName(id) {
      return new Promise(async (resolve, reject) => {
        await UserObject.getProfile(id)
          .then(res => {
            let res_data = res.data;
            this.currTester = res_data.userName;
          })
          .catch(function(error) {
            // request failure handler
            that.$data.isLoading = false;
          });
      });
    },

    async getCurrTester(testerIndex) {
      if (testerIndex >= this.testerList.length) {
        testerIndex = 0;
      } else if (testerIndex < 0) {
        testerIndex = this.testerList.length - 1;
      }
      this.currTesterID = testerIndex;
      this.testerResponse = this.allResponses[this.currTesterID]
      await this.getTesterName(this.testerResponse.testerID);
    },
    */
    switchViews() {
      this.individual = !this.individual;
    }
  }
};

</script>

<style scoped>

.testers-detail-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  width: 100%;
  position: relative; /* Add this to create positioning context */
}

.testers-detail-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 10%;
  min-height: 10%;
  width: 100%;
  background-color: #fff;
  border-radius: 10px;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
}

.testers-detail-title {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.testers-detail-title-text {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 46px;
  color: #fc7727;
  vertical-align: bottom;
}

.testers-detail-name {
  font-family: Lato;
  font-style: italic;
  font-weight: bold;
  margin-left: 10px;
  margin-top: 15px;
  color: #909090;
  vertical-align: bottom;
}

.testers-detail-body {
  margin-left: 5%;
  margin-right: 5%;
  overflow-y: auto;
  flex: 1;
  padding-bottom: 80px; /* Add space for the save button */
}

.testers-detail-body::-webkit-scrollbar {
  display: none;
}

.testers-detail-description-text {
  font-family: Lato;
  color: #bebebe;
}

.testers-detail-subtitle {
  font-family: Lato;
  font-style: normal;
  font-size: 20px;
  line-height: 46px;
  margin-top: 5px;
}

.testers-btn {
  background-color: #fc7727 !important;
  color: #fff;
  border: none;
  border-radius: 10px !important;
  height: fit-content;
  margin-right: 2.5%;
  display: flex;
  flex-direction: row;
}


.testers-btn:hover {
  background-color: #ff8e4d !important;
}


.category {
  font-weight: bold;
}

.testers-section {
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.section-header {
  color: #fc7727;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
}

.section-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.section-header-row .section-header {
  margin-bottom: 0;
}

.empty-hint {
  color: #999;
  font-size: 14px;
  padding: 6px 0;
}

.pending-tag {
  margin-left: 8px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: 2px 8px;
  border-radius: 10px;
}

.pending-add {
  color: #2e7d32;
  background: rgba(76, 175, 80, 0.12);
}

.pending-remove {
  color: #c62828;
  background: rgba(219, 51, 96, 0.1);
}

.update-assignments-btn {
  display: block;
  margin: 4px 0 20px auto;
  background-color: #fff;
  color: #fc7727;
  border: 2px solid #fc7727;
  border-radius: 10px;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
}

.update-assignments-btn:hover:not(:disabled) {
  background-color: #fc7727;
  color: #fff;
}

.update-assignments-btn:disabled {
  border-color: #ddd;
  color: #bbb;
  cursor: not-allowed;
}

.header-left {
  margin-left: 5%;
  display: flex;
  flex-direction: row;
}

.header-right {
  margin-right: 2.5%;
  display: flex;
  flex-direction: row;
}
.testers-list {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  width: 100%;
  align-items: center;
  overflow: auto;
}
.testers-text-container {
  display: flex;
  flex-direction: column;
  width: 60%;
}
.tester-title {
  color: #000 !important;
  font-size: large;
  font-weight: bold;
}
.testers-detail-subtitle.category {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.user-slot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 4px;
  border-bottom: 1px solid #f2f2f2;
  transition: background-color 0.15s ease;
}
.user-slot:last-child {
  border-bottom: none;
}
.user-slot:hover {
  background-color: #fff6ef;
}
.select-all-box {
  margin-right: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #666;
  display: flex;
  align-items: center;
  gap: 6px;
}
.select-all-box input {
  accent-color: #fc7727;
  width: 15px;
  height: 15px;
  cursor: pointer;
}
.user-name {
  margin-left: 10px;
  font-size: 14px;
  color: #333;
}
.user-checkbox {
  margin-right: 10px;
  margin-left: auto;
  width: 16px;
  height: 16px;
  accent-color: #fc7727;
  cursor: pointer;
}

/* New styles for Save button and dialog */
.save-button-container {
  position: absolute;
  bottom: 20px;
  left: 20px;
  z-index: 10;
}

.save-button {
  background-color: #fc7727;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.save-button:hover:not(:disabled) {
  background-color: #ff8e4d;
}

.save-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

/* Dialog overlay */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-box {
  background-color: white;
  border-radius: 10px;
  padding: 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 90%;
}

.dialog-content {
  padding: 30px;
  text-align: center;
}

.dialog-content h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 20px;
}

.dialog-content p {
  margin: 0 0 25px 0;
  color: #666;
  font-size: 16px;
}

.dialog-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.dialog-button {
  padding: 10px 25px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.confirm-button {
  background-color: #fc7727;
  color: white;
}

.confirm-button:hover {
  background-color: #ff8e4d;
}

.cancel-button {
  background-color: #cccccc;
  color: #333;
}

.cancel-button:hover {
  background-color: #bbbbbb;
}

</style>


// WEBPACK FOOTER //
// src/components/game-detail/Recordings/AddTester.vue